/**
 * Defines which static methods must other URL builder classes implement.
 * Meant to be extended by other classes
 *
 * @interface
 */
export default class RefinementURLBuilder {
    /**
     * @returns {string} url
     */
    static getStartingURL() {
        return '';
    }

    /**
     * @returns {string} url
     */
    static getCurrentURL() {
        return new URL(window.location.href).toString();
    }

    /**
     * @param {string} id - id of the refinement
     * @param {any} value - value of the refinement
     * @returns {string} url
     */
    static getRefinementValueURL(id, value) {
        throw new Error(`Not implemented ${id}|${value}`);
    }

    /**
     * @static
     * @param {Object<string, any>} filters - filters to append
     * @returns {string} url
     */
    static getMultipleRefinementsValuesURL(filters) {
        throw new Error(`Not implemented ${filters}`);
    }

    /**
     * @param {string} id - id of the refinement
     * @param {any} value - value of the refinement
     * @returns {string} url
     */
    static getRefinementValueRemoveURL(id, value) {
        throw new Error(`Not implemented ${id}|${value}`);
    }

    /**
     * @param {string} id - id of the refinement
     * @returns {string} url
     */
    static getRefinementRemoveURL(id) {
        throw new Error(`Not implemented ${id}`);
    }

    /**
     * @param {string} page - next page
     * @returns {string} url
     */
    static getNextPageURL(page) {
        throw new Error(`Not implemented ${page}`);
    }
}
